import { useState, useCallback } from 'react';

/**
 * Megőrzi a felhasználó által választott nézetmódot (pl. 'cards', 'table', 'accordion')
 * a böngésző helyi tárolójában (localStorage), így más menüre váltva és visszatérve
 * automatikusan a legutóbb beállított nézet jelenik meg.
 */
export function usePersistedViewMode<T extends string>(
  storageKey: string,
  defaultMode: T,
  allowedModes?: readonly T[]
): [T, (newMode: T) => void] {
  const fullKey = `kozat_view_mode_${storageKey}`;

  const [mode, setModeState] = useState<T>(() => {
    try {
      const saved = localStorage.getItem(fullKey);
      if (saved) {
        if (!allowedModes || allowedModes.includes(saved as T)) {
          return saved as T;
        }
      }
    } catch {
      // localStorage hiba esetén alapértelmezett értéket használunk
    }
    return defaultMode;
  });

  const setMode = useCallback(
    (newMode: T) => {
      setModeState(newMode);
      try {
        localStorage.setItem(fullKey, newMode);
      } catch (e) {
        console.warn('Nem sikerült elmenteni a nézetmódot localStorage-ba:', e);
      }
    },
    [fullKey]
  );

  return [mode, setMode];
}
